import { toIsoString } from "../utils/formatDate";
import api from "./api";

const endpoint = "timeline";

export class SolicitationService {
  static list({
    desc,
    page,
    limit,
    protocol,
    processorClientId,
    startDate,
    endDate,
  } = {}) {
    return api
      .get(endpoint, {
        desc,
        page,
        limit,
        protocol,
        sorter: "created_at,descend",
        processor_client_id: processorClientId,
        startDate: toIsoString(startDate),
        endDate: toIsoString(endDate),
      })
      .then((response) => ({
        ...response.data,
        data: response?.data?.data?.map((item) => ({
          key: item.id,
          ...item,
        })),
      }));
  }
}
